import { bind } from '../call'
import { ENDPOINTS } from '../endpoints'

export const getUserAppPreferences = bind(ENDPOINTS.getUserAppPreferences)
export const patchUserAppPreferences = bind(ENDPOINTS.patchUserAppPreferences)
export const listTutorialPractice = bind(ENDPOINTS.listTutorialPractice)
export const putTutorialPractice = bind(ENDPOINTS.putTutorialPractice)
export const listTutorialProgress = bind(ENDPOINTS.listTutorialProgress)
export const putTutorialProgress = bind(ENDPOINTS.putTutorialProgress)
export const getHome = bind(ENDPOINTS.getHome)
export const listNotifications = bind(ENDPOINTS.listNotifications)
export const getOnboarding = bind(ENDPOINTS.getOnboarding)
export const putOnboarding = bind(ENDPOINTS.putOnboarding)
export const getWorkspacePreferences = bind(ENDPOINTS.getWorkspacePreferences)
export const patchWorkspacePreferences = bind(ENDPOINTS.patchWorkspacePreferences)
